import * as dom from './dom.js';
import * as compass from './ui/compass.js';
import * as triangle from './triangle.js';
import * as player from './player.js';

export {
    init,
    keyDown,
    enableHotKeys,
}

const keys = {};
let hotKeysEnabled = false;

function init() {
    document.addEventListener('keydown', (e) => {
        if (e.repeat) return;
        if (DEVMODE) console.log('Key down:', e.key);

        keys[e.key] = true;

        if (!hotKeysEnabled) return;
        switch (e.key) {
            case 'm':
                dom.showMap();
                break;
        }

        // FIXME: Debug only
        if (DEVMODE) {
            if (['1', '2', '3', '4', '5', '6', '7', '8'].includes(e.key)) {
                triangle.drop(`stonehenge-triangle-${e.key}`, player.position, {
                    offset: { x: 1, y: 1 },
                });
            }

            if (e.key === '0') {
                triangle.activateTriangle('stonehenge-triangle-1');
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-2'), 100);
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-3'), 200);
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-4'), 300);
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-5'), 400);
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-6'), 500);
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-7'), 600);
                setTimeout(() => triangle.activateTriangle('stonehenge-triangle-8'), 700);
            }

            switch (e.key) {    
                case 'z':
                    compass.zoomToOrigin();
                    break;
                case 'p':
                    compass.zoomToPlayer();
                    break;
            }
        }
    });
    document.addEventListener('keyup', (e) => {
        keys[e.key] = false;
    });
}

function keyDown(key) {
    return !!keys[key];
}

function enableHotKeys(bool = true) {
    hotKeysEnabled = bool;
}